import React from "react";

const DataHome = [
    {
        id: 1,
        name: 'Manicure',
        description: 'Experience the ultimate hand pampering with our professional manicure services. From shaping and buffing to a perfect polish, achieve stunning nails that reflect your personal style.',
        img: require("../img/manicure.png"),
    },
    {
        id: 2,
        name: 'Pedicure',
        description: 'Indulge in a relaxing pedicure session that not only beautifies your feet but also soothes and rejuvenates. Our expert care ensures soft, smooth skin and impeccably polished toes.',
        img: require("../img/pedicure.png"),
    },
    {
        id: 3,
        name: 'Eye Lash',
        description: 'Enhance your eyes with our eyelash extension services. Customizable to your preference, achieve a natural or dramatic look with fuller, longer lashes that brighten and enlarge your eyes.',
        img: require("../img/eyelash.png"),
    },
    {
        id: 4,
        name: 'Custom Design',
        description: 'Unleash your creativity with our custom design services. Tailored to your unique vision, we create personalized nail art and beauty enhancements that stand out and express your individuality.',
        img: require("../img/custom.png"),
    },
    {
        id: 5,
        name: 'Gel-X',
        description: 'Transform your nails with Gel-X extensions, the latest in nail innovation. Enjoy durable, lightweight, and natural-looking nails tailored to your desired length and shape for weeks.',
        img: require("../img/gelxtest.png"),
    },
];

export default DataHome;